import styled from "@emotion/styled";
import { Box, Button, Grid } from "@mui/material";
import { useEffect, useRef } from "react";
import SignatureCanvas from "react-signature-canvas";

const Main = styled(Box)(({ height = '200px' }) => ({
  height: height,
  
  ".canvasStyle": {
    background: "#f7f7f7 !important",
    width: "100%",
    height: "100%",
    border: "1px solid #282828",
  },

  '.clearButton': {
    marginTop: '-20px',
    marginRight: '10px',
    width: '70px',
    height: '30px',
    fontSize: '12px'
  }
}));

export default function DigitalSignature({ setSignature, showButton = true, height, clean }) {
  const canvas = useRef({});
  const sendData = () => {
    setSignature(canvas.current.getCanvas().toDataURL("image/png"));
  };

  useEffect(() => {
    clean && canvas.current.clear();
  }, [clean])

  return (
    <Main height={height}>
      <SignatureCanvas
        penColor="black"
        ref={canvas}
        onEnd={sendData}
        canvasProps={{ className: "canvasStyle" }}
      />
      {showButton && <Box display={"flex"} justifyContent={"flex-end"}>
        <Button
          className="clearButton"
          variant="contained"
          color="secondary"
          onClick={() => (canvas.current.clear(), setSignature(null))}
        >
          {"Limpiar"}
        </Button>
      </Box>}
    </Main>
  );
}
